'use strict';
define(['app'], function (app) {
    app.factory('SuiteTheme', SuiteTheme);

    SuiteTheme.$inject = ['$document', '$rootScope', '$window'];

    function SuiteTheme($document, $rootScope, $window) {
        var STORAGE_KEY = 'sto-suite-theme';
        var PREFERENCES = ['light', 'dark', 'system'];
        var root = $document[0].documentElement;
        var mediaQuery = $window.matchMedia ? $window.matchMedia('(prefers-color-scheme: dark)') : null;

        function normalizePreference(value) {
            return PREFERENCES.indexOf(value) !== -1 ? value : 'system';
        }

        function getStoredPreference() {
            try {
                return $window.localStorage.getItem(STORAGE_KEY);
            } catch (error) {
                return null;
            }
        }

        function getPreference() {
            return normalizePreference(getStoredPreference());
        }

        function systemMode() {
            return mediaQuery && mediaQuery.matches ? 'dark' : 'light';
        }

        function resolvedMode(preference) {
            return preference === 'system' ? systemMode() : preference;
        }

        function getMode() {
            return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        }

        function isDark() {
            return getMode() === 'dark';
        }

        function applyPreference(preference, persist) {
            var nextPreference = normalizePreference(preference);
            var nextMode = resolvedMode(nextPreference);
            root.setAttribute('data-theme', nextMode);
            root.setAttribute('data-theme-preference', nextPreference);
            root.style.colorScheme = nextMode;

            if (persist) {
                try {
                    $window.localStorage.setItem(STORAGE_KEY, nextPreference);
                } catch (error) {
                    // Storage can be unavailable in private or restricted contexts.
                }
            }

            $rootScope.$broadcast('suiteThemeChanged', nextMode, nextPreference);
            return nextMode;
        }

        function toggle() {
            return applyPreference(isDark() ? 'light' : 'dark', true);
        }

        if (mediaQuery) {
            var handleSystemTheme = function (event) {
                if (getPreference() === 'system') {
                    $rootScope.$evalAsync(function () {
                        applyPreference('system', false);
                    });
                }
            };
            if (mediaQuery.addEventListener) {
                mediaQuery.addEventListener('change', handleSystemTheme);
            } else if (mediaQuery.addListener) {
                mediaQuery.addListener(handleSystemTheme);
            }
        }

        applyPreference(getPreference(), false);

        return {
            getMode: getMode,
            getPreference: getPreference,
            isDark: isDark,
            setMode: function (mode) { return applyPreference(mode, true); },
            setPreference: function (preference) { return applyPreference(preference, true); },
            toggle: toggle
        };
    }
});
